import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Header } from "./Header";
import { classNameFactory } from "@src/utils/dom";
import "./homeLayout.scss";
const cn = classNameFactory("home-layout");
export const HomeLayout = props => {
    const { children } = props;
    return (_jsxs("div", { className: cn(""), children: [_jsx(Header, {}), children] }));
};
